import * as React from 'react'

import { CompetenciesCompetencyCrumbQuery } from 'generated/resources/graphql'

type FeaturesFeature = NonNullable<
  NonNullable<
    CompetenciesCompetencyCrumbQuery['features']['featuresConnection']
  >['nodes'][number]
>

import createContext from 'modules/core/hooks/createContext'

export type CompetenciesConfig = {
  isJobCatalogTreeEnabled: boolean
}

export type CompetenciesFeatures = Pick<FeaturesFeature, 'name' | 'id' | 'enabled'>[]
type ProviderType = {
  features: CompetenciesFeatures
}

const buildCompetenciesConfig = (features: CompetenciesFeatures): CompetenciesConfig => {
  if (!features || features.length === 0) {
    return {
      isJobCatalogTreeEnabled: false,
    }
  }

  const featureMap = new Map(features.map((f) => [f.name, f.enabled]))
  const isLegacyJobCatalogEnabled = featureMap.get('legacy_job_catalog') ?? false
  const isJobCatalogTreeEnabled = !isLegacyJobCatalogEnabled

  return {
    isJobCatalogTreeEnabled,
  }
}

const { context: CompetenciesFeaturesContext, hook: useCompetenciesFeatures } =
  createContext<CompetenciesConfig>()

const CompetenciesFeaturesProvider = ({
  children,
  features,
}: React.PropsWithChildren<ProviderType>) => {
  const context = buildCompetenciesConfig(features)

  return (
    <CompetenciesFeaturesContext.Provider value={context}>
      {children}
    </CompetenciesFeaturesContext.Provider>
  )
}

export { CompetenciesFeaturesProvider, useCompetenciesFeatures, buildCompetenciesConfig }
